import { lazy } from "react";

// project imports
import Loadable from "components/Loadable";
import DashboardLayout from "layout/Dashboard";
import PagesLayout from "layout/Pages";
import SimpleLayout from "layout/Simple";

import { SimpleLayoutType } from "config";

// pages routing
const MaintenanceError = Loadable(lazy(() => import("pages/maintenance/404")));
const MaintenanceError500 = Loadable(
  lazy(() => import("pages/maintenance/500")),
);
const MaintenanceUnderConstruction = Loadable(
  lazy(() => import("pages/maintenance/under-construction")),
);
const MaintenanceComingSoon = Loadable(
  lazy(() => import("pages/maintenance/coming-soon")),
);

const AppContactUS = Loadable(lazy(() => import("pages/contact-us")));
const RunwayDashboard = Loadable(lazy(() => import("pages/runway/Dashboard")));
const PearsonMap = Loadable(lazy(() => import("pages/runway/PearsonMap")));
const AirportMap = Loadable(lazy(() => import("pages/runway/AirportMap")));
const WashroomMap = Loadable(lazy(() => import("pages/runway/WashroomMap")));
const FacilityMap = Loadable(lazy(() => import("pages/runway/FacilityMap")));
const FacilityModelling = Loadable(
  lazy(() => import("pages/runway/FacilityModelling")),
);
const UserTable = Loadable(lazy(() => import("pages/runway/UserTable")));
const ShiftScheduling = Loadable(
  lazy(() => import("pages/runway/ShiftScheduling")),
);
const ShiftScheduler = Loadable(
  lazy(() => import("pages/runway/ShiftScheduler")),
);
const Simulation = Loadable(lazy(() => import("pages/runway/Simulation")));
const Simulation2 = Loadable(lazy(() => import("pages/runway/Simulation2")));
const Flights = Loadable(lazy(() => import("pages/runway/Flights")));
const Flights2 = Loadable(lazy(() => import("pages/runway/Flights2")));
const Traffic = Loadable(lazy(() => import("pages/runway/Traffic")));
const FlowGraph = Loadable(lazy(() => import("pages/runway/FlowGraph")));
const CrowdPrediction = Loadable(
  lazy(() => import("pages/runway/CrowdPrediction")),
);
const Deterioration = Loadable(
  lazy(() => import("pages/runway/Deterioration")),
);
const StaffPresence = Loadable(lazy(() => import("pages/runway/Presence")));
const TaskTimeline = Loadable(lazy(() => import("pages/runway/TaskTimeline")));
const CreateTask = Loadable(lazy(() => import("pages/runway/CreateTask")));
const AuditHistory = Loadable(lazy(() => import("pages/runway/AuditHistory")));
const Issues = Loadable(lazy(() => import("pages/runway/Issues")));
const IssueTypes = Loadable(lazy(() => import("pages/runway/IssueTypes")));
const TaskSchedule = Loadable(lazy(() => import("pages/runway/TaskSchedule")));
const EditTimeline = Loadable(lazy(() => import("pages/runway/EditTimeline")));
const ShiftRosterControlCenter = Loadable(
  lazy(() => import("pages/runway/ShiftRosterControlCenter")),
);
const Rescheduling = Loadable(lazy(() => import("pages/runway/Rescheduling")));
const TaskAnalysis = Loadable(lazy(() => import("pages/runway/TaskAnalysis")));
const TaskIntelligence = Loadable(
  lazy(() => import("pages/runway/TaskIntelligence")),
);
const FlightSchedule = Loadable(
  lazy(() => import("pages/runway/FlightSchedule")),
);
const HumanResource = Loadable(
  lazy(() => import("pages/runway/HumanResource")),
);
const AccessManagement = Loadable(
  lazy(() => import("pages/runway/AccessManagement")),
);
const FlightData = Loadable(lazy(() => import("pages/runway/FlightData")));
const TaskScheduling = Loadable(
  lazy(() => import("pages/runway/TaskScheduling")),
);
const TaskSettings = Loadable(lazy(() => import("pages/runway/TaskSettings")));
const TaskSettings2 = Loadable(
  lazy(() => import("pages/runway/TaskSettings2")),
);
const TaskAssignment = Loadable(
  lazy(() => import("pages/runway/TaskAssignment")),
);
const TaskHistory = Loadable(lazy(() => import("pages/runway/TaskHistory")));
const BatchEdit = Loadable(lazy(() => import("pages/runway/BatchEdit")));
const ReportsTasks = Loadable(lazy(() => import("pages/runway/ReportsTasks")));
const StaffingCalendar = Loadable(
  lazy(() => import("pages/runway/StaffingCalendar")),
);
const MasterSchedule = Loadable(
  lazy(() => import("pages/runway/MasterSchedule")),
);
const TaskLines = Loadable(lazy(() => import("pages/runway/TaskLines")));
const UsersWorkers = Loadable(
  lazy(() => import("pages/administration/user-management/UsersWorkers")),
);
const CreateUser = Loadable(
  lazy(() => import("pages/administration/user-management/CreateUser")),
);
const Availability = Loadable(
  lazy(() => import("pages/administration/user-management/Availability")),
);
const AdminSetting = Loadable(
  lazy(() => import("pages/administration/user-management/AdminSetting")),
);
const TaskType = Loadable(
  lazy(() => import("pages/administration/task-settings/TaskType")),
);
const AuditType = Loadable(
  lazy(() => import("pages/administration/task-settings/AuditType")),
);
const ShiftDefinition = Loadable(
  lazy(() => import("pages/administration/task-settings/ShiftDefinition")),
);
const WorkArea = Loadable(
  lazy(() => import("pages/administration/task-settings/WorkArea")),
);
const Lines = Loadable(
  lazy(() => import("pages/administration/task-settings/Lines")),
);
const DutyClassSetting = Loadable(
  lazy(() => import("pages/administration/task-settings/DutyClassSetting")),
);
const AssetType = Loadable(
  lazy(() => import("pages/administration/assets/AssetType")),
);
const AssetInventory = Loadable(
  lazy(() => import("pages/administration/assets/AssetInventory")),
);
const CreateAsset = Loadable(
  lazy(() => import("pages/administration/assets/CreateAsset")),
);
const RegisteredLocations = Loadable(
  lazy(() => import("pages/administration/assets/RegisteredLocations")),
);
const UIConfig = Loadable(
  lazy(() => import("pages/administration/general-setting/UIConfig")),
);
const StaffLinePreferences = Loadable(
  lazy(
    () => import("pages/administration/general-setting/StaffLinePreferences"),
  ),
);
const TaskDuration = Loadable(
  lazy(() => import("pages/administration/general-setting/TaskDuration")),
);
const AuthApisPage = Loadable(
  lazy(() => import("pages/pages/apis/AuthApisPage")),
);
const PositionsApisPage = Loadable(
  lazy(() => import("pages/pages/apis/PositionsApisPage")),
);
const AirportsApisPage = Loadable(
  lazy(() => import("pages/pages/apis/AirportsApisPage")),
);
const UsersApisPage = Loadable(
  lazy(() => import("pages/pages/apis/UsersApisPage")),
);
const ItemTypesApisPage = Loadable(
  lazy(() => import("pages/pages/apis/ItemTypesApisPage")),
);
const AssetsApisPage = Loadable(
  lazy(() => import("pages/pages/apis/AssetsApisPage")),
);
const CleaningTaskTypesApisPage = Loadable(
  lazy(() => import("pages/pages/apis/CleaningTaskTypesApisPage")),
);
const ShiftDefinitionsApisPage = Loadable(
  lazy(() => import("pages/pages/apis/ShiftDefinitionsApisPage")),
);
const AvailabilityApisPage = Loadable(
  lazy(() => import("pages/pages/apis/AvailabilityApisPage")),
);
const WorkAreasApisPage = Loadable(
  lazy(() => import("pages/pages/apis/WorkAreasApisPage")),
);
const LinesApisPage = Loadable(
  lazy(() => import("pages/pages/apis/LinesApisPage")),
);

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  errorElement: <MaintenanceError500 />,
  children: [
    {
      path: "/",
      element: <DashboardLayout />,
      children: [
        {
          index: true,
          element: <RunwayDashboard />,
        },
        {
          path: "dashboard",
          element: <RunwayDashboard />,
        },
        {
          path: "pearson-map",
          element: <PearsonMap />,
        },
        {
          path: "airport-map",
          element: <AirportMap />,
        },
        {
          path: "washroom-map",
          element: <WashroomMap />,
        },
        {
          path: "facility-map",
          element: <FacilityMap />,
        },
        {
          path: "facility-modelling",
          element: <FacilityModelling />,
        },
        {
          path: "staff-management",
          element: <UserTable />,
        },
        {
          path: "human-resource",
          element: <HumanResource />,
        },
        {
          path: "access-management",
          element: <AccessManagement />,
        },
        {
          path: "shift-scheduling",
          element: <ShiftScheduling />,
        },
        {
          path: "shift-scheduler",
          element: <ShiftScheduler />,
        },
        {
          path: "staffing-calendar",
          element: <StaffingCalendar />,
        },
        {
          path: "master-schedule",
          element: <MasterSchedule />,
        },
        {
          path: "task-lines",
          element: <TaskLines />,
        },
        {
          path: "task-scheduling",
          element: <TaskScheduling />,
        },
        {
          path: "simulation",
          element: <Simulation />,
        },
        {
          path: "simulation-2",
          element: <Simulation2 />,
        },
        {
          path: "flights",
          element: <Flights />,
        },
        {
          path: "flights-2",
          element: <Flights2 />,
        },
        {
          path: "traffic",
          element: <Traffic />,
        },
        {
          path: "flow-graph",
          element: <FlowGraph />,
        },
        {
          path: "crowd-prediction",
          element: <CrowdPrediction />,
        },
        {
          path: "task-timeline",
          element: <TaskTimeline />,
        },
        {
          path: "staff-presence",
          element: <StaffPresence />,
        },
        {
          path: "create-task",
          element: <CreateTask />,
        },
        {
          path: "audit",
          element: <AuditHistory />,
        },
        {
          path: "issues",
          element: <Issues />,
        },
        {
          path: "issue-type",
          element: <IssueTypes />,
        },
        {
          path: "issue-types",
          element: <IssueTypes />,
        },
        {
          path: "deterioration",
          element: <Deterioration />,
        },
        {
          path: "task-schedule",
          element: <TaskSchedule />,
        },
        {
          path: "edit-timeline",
          element: <EditTimeline />,
        },
        {
          path: "shift-roster-control",
          element: <ShiftRosterControlCenter />,
        },
        {
          path: "rescheduling",
          element: <Rescheduling />,
        },
        {
          path: "task-analysis",
          element: <TaskAnalysis />,
        },
        {
          path: "task-intelligence",
          element: <TaskIntelligence />,
        },
        {
          path: "task-assignment",
          element: <TaskAssignment />,
        },
        {
          path: "task-settings",
          element: <TaskSettings />,
        },
        {
          path: "task-settings-2",
          element: <TaskSettings2 />,
        },
        {
          path: "task-history",
          element: <TaskHistory />,
        },
        {
          path: "batch-edit",
          element: <BatchEdit />,
        },
        {
          path: "reports/tasks",
          element: <ReportsTasks />,
        },
        {
          path: "flight-schedule",
          element: <FlightSchedule />,
        },
        {
          path: "flight-data",
          element: <FlightData />,
        },
        {
          path: "administration/user-management",
          element: <UsersWorkers />,
        },
        {
          path: "administration/user-management/users-workers",
          element: <UsersWorkers />,
        },
        {
          path: "administration/user-management/create-user",
          element: <CreateUser />,
        },
        {
          path: "administration/user-management/availability",
          element: <Availability />,
        },
        {
          path: "administration/user-management/admin-setting",
          element: <AdminSetting />,
        },
        {
          path: "profile",
          element: <AdminSetting />,
        },
        {
          path: "my-account",
          element: <AdminSetting />,
        },
        {
          path: "administration/assets/type",
          element: <AssetType />,
        },
        {
          path: "administration/assets/inventory",
          element: <AssetInventory />,
        },
        {
          path: "administration/assets/create",
          element: <CreateAsset />,
        },
        {
          path: "administration/assets/registered-locations",
          element: <RegisteredLocations />,
        },
        {
          path: "administration/general-setting/ui-config",
          element: <UIConfig />,
        },
        {
          path: "administration/general-setting/staff-line-preferences",
          element: <StaffLinePreferences />,
        },
        {
          path: "administration/task-settings/task-duration",
          element: <TaskDuration />,
        },
        {
          path: "administration/task-settings/task-type",
          element: <TaskType />,
        },
        {
          path: "administration/task-settings/audit-type",
          element: <AuditType />,
        },
        {
          path: "administration/task-settings/issue-type",
          element: <IssueTypes />,
        },
        {
          path: "administration/task-settings/issue-types",
          element: <IssueTypes />,
        },
        {
          path: "administration/task-settings/shift-definition",
          element: <ShiftDefinition />,
        },
        {
          path: "administration/task-settings/work-area",
          element: <WorkArea />,
        },
        {
          path: "administration/task-settings/lines",
          element: <Lines />,
        },
        {
          path: "administration/task-settings/duty-class-setting",
          element: <DutyClassSetting />,
        },
        {
          path: "pages/apis/auth",
          element: <AuthApisPage />,
        },
        {
          path: "pages/apis/positions",
          element: <PositionsApisPage />,
        },
        {
          path: "pages/apis/airports",
          element: <AirportsApisPage />,
        },
        {
          path: "pages/apis/users",
          element: <UsersApisPage />,
        },
        {
          path: "pages/apis/item-types",
          element: <ItemTypesApisPage />,
        },
        {
          path: "pages/apis/assets",
          element: <AssetsApisPage />,
        },
        {
          path: "pages/apis/cleaning-task-types",
          element: <CleaningTaskTypesApisPage />,
        },
        {
          path: "pages/apis/shift-definitions",
          element: <ShiftDefinitionsApisPage />,
        },
        {
          path: "pages/apis/availability",
          element: <AvailabilityApisPage />,
        },
        {
          path: "pages/apis/work-areas",
          element: <WorkAreasApisPage />,
        },
        {
          path: "pages/apis/lines",
          element: <LinesApisPage />,
        },
      ],
    },
    {
      path: "/maintenance",
      element: <PagesLayout />,
      children: [
        {
          path: "404",
          element: <MaintenanceError />,
        },
        {
          path: "500",
          element: <MaintenanceError500 />,
        },
        {
          path: "under-construction",
          element: <MaintenanceUnderConstruction />,
        },
        {
          path: "coming-soon",
          element: <MaintenanceComingSoon />,
        },
      ],
    },
    {
      path: "/",
      element: <SimpleLayout layout={SimpleLayoutType.SIMPLE} />,
      children: [
        {
          path: "contact-us",
          element: <AppContactUS />,
        },
      ],
    },
  ],
};

export default MainRoutes;
